module.exports = __webpack_public_path__ + "img/glass-empty.7f6d5614.svg";